import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import qs from 'qs';

import { fetchUserPaymentMethods } from 'actions/payments';
import {
  getUserPaymentMethods,
  getPageCount,
  getLoggedInUser,
  getIsAdmin,
  getIncludedInGroups,
} from 'reducers';

const withPurchaseMethods = (DecoratedComponent) => {
  class WithPurchaseMethods extends Component {
    componentDidMount() {
      this.fetchPaymentMethods();
    }

    componentDidUpdate(oldProps) {
      if (!oldProps.user && this.props.user) {
        this.fetchPaymentMethods();
        return;
      }

      if (oldProps.userId !== this.props.userId) {
        this.fetchPaymentMethods();
        return;
      }

      if (oldProps.page !== this.props.page) {
        this.fetchPaymentMethods();
      }
    }

    fetchPaymentMethods() {
      const { fetchUserPaymentMethods, user, page } = this.props;
      if (user) {
        fetchUserPaymentMethods(user.id, page);
      }
    }

    render() {
      const { children, ...props } = this.props;
      return React.createElement(DecoratedComponent, props, children);
    }
  }

  const mapStateToProps = (state, { location: { search } }) => {
    const { page = 1 } = qs.parse(search, { ignoreQueryPrefix: true });
    const paymentMethods = getUserPaymentMethods(state, page);

    return {
      paymentMethods,
      pageCount: getPageCount(state, 'payments', `fetchByUser`, page),
      page,
      loggedInUser: getLoggedInUser(state),
      isAdmin: getIsAdmin(state),
      isAdminOrManagerOrBilling: getIncludedInGroups(state, [
        'ADMIN',
        'MANAGER',
        'BILLING',
      ]),
      isAdminOrBilling: getIncludedInGroups(state, ['ADMIN', 'BILLING']),
      isBusinessOrReseller: getIncludedInGroups(state, [
        'BUSINESS',
        'RESELLER',
      ]),
      isBusiness: getIncludedInGroups(state, ['BUSINESS']),
    };
  };

  const mapDispatchToProps = {
    fetchUserPaymentMethods,
  };

  return compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
  )(WithPurchaseMethods);
};

export default withPurchaseMethods;
